module.exports = __webpack_public_path__ + "static/media/cny.5bb0dfef.svg";